<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <div>
      <LmComponentLoading v-if="isLoading" fixed />
      <LmBreadcrumb v-if="showBreadcrumb" />
      <h4>Anular el Pase del Expediente {{itemDetail.expediente}}</h4>
        <div>
        </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="submit"
          buttonClass="btn-danger"
          :isProcessing="formIsProcessing"
          :value="$t('Anular')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {},
      formIsProcessing: false,
      isLoading: true
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail'])
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      default: true
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    ...mapActions('commons', ['deleteItem', 'getItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.push(this.onSuccessDestinationRoute)
    },
    cancelBtn () {
      this.$router.push(`/pases/delexpediente/${this.itemDetail.numero_transaccion}`)
    },
    submit () {
      let deleteAttributes = {
        id: this.$route.params.id
      }
      this.deleteItem({
        path: 'pases/delete/',
        data: deleteAttributes
      })
        .then(() => {
          this.formIsProcessing = false
          this.$router.push(`/pases/delexpediente/${this.itemDetail.numero_transaccion}`)
        })
        .catch(e => {
          this.formIsProcessing = false
          console.log(e)
          alert(this.$t('try_again_later'))
        })
    }
  },
  created () {
    (async () => {
      // Se obtiene el ID de oficina del usuario logeado
      await this.getItemDetail({
        path: 'pases/edit/',
        id: this.$route.params.id
      })
      this.isLoading = false
    })()
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
